export default "__VITE_ASSET__B1OYHkh8__"